import { ActivityEntityName, EntityQueueFieldSource, EntityViewDisplay, EntityViewSortDirection } from '@jms/model';
import { dedupeLabels, resolveColumnUiFields, toQueueFieldOptions } from '../../queue.field.options';
import { createFlagAdapter } from './flag.step.adapter';
import { QueueAdapterDeps, QueueStepAdapter } from './queue.step.adapter';

export const createFlagJobAdapter = (deps: QueueAdapterDeps): QueueStepAdapter =>
  createFlagAdapter(deps, {
    entity: ActivityEntityName.Job,
    entityLabel: 'Job',
    resolveColumnOptions: map => {

      const flagMeta = map[ActivityEntityName.Flag];
      const jobMeta = map[ActivityEntityName.Job];
      const flagFields = flagMeta ? toQueueFieldOptions(resolveColumnUiFields(flagMeta), 'flag', 'Flags', true) : [];
      const jobFields = jobMeta ? toQueueFieldOptions(resolveColumnUiFields(jobMeta), 'entity', jobMeta.displayName ?? 'Job', true) : [];
      return dedupeLabels(flagFields, jobFields);
    },
    defaultTable: () => ({
      display: EntityViewDisplay.Table,
      fixed: [],
      other: [
        { ref: { source: EntityQueueFieldSource.Flag, path: 'flag.createdAt' }, name: 'Created', visible: true },
        { ref: { source: EntityQueueFieldSource.Flag, path: 'flag.message' }, name: 'Flag · Message', visible: true },
        { ref: { source: EntityQueueFieldSource.Flag, path: 'flag.category' }, name: 'Flag · Category', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.jobNumber' }, name: 'Job · Job Number', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.customer' }, name: 'Job · Customer', visible: true },
      ],
      sortBy: { source: EntityQueueFieldSource.Flag, path: 'flag.createdAt' },
      sortOrder: EntityViewSortDirection.Desc,
    }),
  });
